export enum ReportingModeEnum {
    Preivew = 0,
    PreviewSingle = 1,
    Print = 2,
    Send = 3
}
